var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useShiftParticipantStorage } from '../../../../ui/hooks';
import React from 'react';
export function useSelectActionsShiftParticipantsTable(allIds) {
    const [selected, setSelected] = React.useState([]);
    const [selectedIds, setSelectedIds] = React.useState([]);
    const shiftParticipantStorage = useShiftParticipantStorage();
    const handleSingleSelect = React.useCallback((row) => {
        setSelected((current) => {
            return current.some((item) => item.id === row.id)
                ? current.filter((item) => item.id !== row.id) // unselect
                : [
                    ...current,
                    {
                        id: row.id,
                        hoursStatus: row.hoursStatus,
                    },
                ]; // select
        });
        setSelectedIds((current) => {
            return current.includes(row.id)
                ? current.filter((id) => id !== row.id) // unselect
                : [...current, row.id]; // select
        });
    }, [setSelected, setSelectedIds]);
    const getSelectAllRecords = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const allRecordsIds = allIds !== null && allIds !== void 0 ? allIds : [];
        const shiftParticipants = yield shiftParticipantStorage.list({
            filter: [
                {
                    op: 'in',
                    id: allRecordsIds,
                },
            ],
        });
        return (_a = shiftParticipants.rows) === null || _a === void 0 ? void 0 : _a.map((participant) => ({
            id: participant.id,
            hoursStatus: participant.columns.hoursStatus,
        }));
    }), [allIds, shiftParticipantStorage]);
    const handleSelectAll = React.useCallback((currentlySelectedIds) => __awaiter(this, void 0, void 0, function* () {
        const allRecordsIds = allIds !== null && allIds !== void 0 ? allIds : [];
        let allRecords = [];
        if (currentlySelectedIds.length !== allRecordsIds.length) {
            allRecords = yield getSelectAllRecords();
        }
        setSelected((prevState) => (prevState.length === allRecordsIds.length ? [] : allRecords));
        setSelectedIds((prevState) => (prevState.length === allRecordsIds.length ? [] : allRecordsIds));
    }), [allIds, getSelectAllRecords, setSelected, setSelectedIds]);
    const handleSelectReset = React.useCallback((rowIds) => {
        if (!rowIds) {
            setSelected([]);
            setSelectedIds([]);
        }
        else {
            setSelected((prevState) => prevState.filter((selectedItem) => !rowIds.includes(selectedItem.id)));
            setSelectedIds((prevState) => prevState.filter((selectedItem) => !rowIds.includes(selectedItem)));
        }
    }, [setSelected, setSelectedIds]);
    return {
        handleSingleSelect,
        handleSelectAll,
        handleSelectReset,
        selected,
        selectedIds,
    };
}
